export function changeMenu(context, action) {
    context.dispatch({
        menuSelect: action
    })
}